module.exports = __webpack_public_path__ + "img/logo7.59087865.png";